import React, { useEffect,useState } from "react";
import PropTypes from "prop-types";
import "./IntroScreenLight.css";
import { useDeviceDetection } from "../../hooks/useDeviceDetection";
import { COLORS_LIGHT } from "../../constants/colors";
import { shuffleArray } from "../../utils/arrayUtils";

const INTRO_FOLDER = `${process.env.PUBLIC_URL}/media/intro`;

const SVGS = {
  logo: `${INTRO_FOLDER}/apropologoFull.svg`, // 
  titreHorizontal: `${INTRO_FOLDER}/titreC.svg`,
  titreVertical: `${INTRO_FOLDER}/titreCv.svg`,
  enter: `${INTRO_FOLDER}/enterB.svg`,
  apropos: `${INTRO_FOLDER}/apropos.svg`,
};

export default function IntroScreenLight({
  onEnter,
  onOpenPresentation,
  invertedCells = {titre: false,
    logo: false,
    apropos: false,
    enter: false,
    Mention:false,},
}) {
  const { isPortrait, isMobile, viewport } = useDeviceDetection();

const [colors, setColors] = useState(() => [...shuffleArray(COLORS_LIGHT)].slice(0, 4));

useEffect(() => {
  // Recalcul à chaque changement de taille/orientation
  setColors([...shuffleArray(COLORS_LIGHT)].slice(0, 5));
}, [viewport.width, viewport.height]);

const [colorTitre, colorLogo, colorApropos, colorEnter, colorMentions] = colors;

  const titreSvg =
    isPortrait && isMobile ? SVGS.titreVertical : SVGS.titreHorizontal;

  const openExternalSite = () => {
    window.open(
      "https://apropo-lessables.com/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const renderMask = (svg, color, inverted, align) => {
    const fill = inverted ? color : "#fff";
    //const fill = inverted ?   "#fff":color;

    return (
      <div
        className="light-mask"
        style={{
          backgroundColor: fill,
          WebkitMaskImage: `url("${svg}")`,
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskSize: "contain",
          WebkitMaskPosition: align,
          maskImage: `url("${svg}")`,
          maskRepeat: "no-repeat",
          maskSize: "contain",
          maskPosition: align,
        }}
      />
    );
  };

return (
  <div className="intro-light-root">
    {/* Zone principale (100vh - 40px) */}
    <div className="intro-light-main">
      {/* 🔝 TITRE */}
      <div
        className="intro-light-top"
        style={{
          backgroundColor: invertedCells.titre ? "#fff" : colorTitre,
        }}
      >
        {renderMask(
          titreSvg,
          colorTitre,
          invertedCells.titre,
          "center center" // "bottom center" 
        )}
      </div>

      {/* 🔻 BAS */}
      <div className="intro-light-bottom">
        {/* LOGO */}
        <div
          className="intro-light-cell"
          style={{
            backgroundColor: invertedCells.logo ? "#fff" : colorLogo,
            cursor: "pointer",
          }}
          onClick={openExternalSite}
          title="APROPO protection du patrimoine"
        >
          {renderMask(
            SVGS.logo,
            colorLogo,
            invertedCells.logo,
            "top center"
          )}
        </div>

        {/* A PROPOS */}
        <div
          className="intro-light-cell"
          style={{
            backgroundColor: invertedCells.apropos ? "#fff" : colorApropos,
            cursor: "pointer",
          }}
          onClick={onOpenPresentation}
          title="à propos des domonymes…"
        >
          {renderMask(
            SVGS.apropos,
            colorApropos,
            invertedCells.apropos,
            "top center"
          )}
        </div>

        {/* ENTER */}
        <div
          className="intro-light-cell"
          style={{
            backgroundColor: invertedCells.enter ? "#fff" : colorEnter,
            cursor: "pointer",
          }}
          onClick={onEnter}

          title="Accès aux domonymes sablais"
        >
          {renderMask(
            SVGS.enter,
            colorEnter,
            invertedCells.enter,
            "top center"
          )}
        </div>
      </div>
    </div>

    {/* 🧾 MENTIONS */}
    <div className="intro-light-mentions"
    
  style={{
    backgroundColor: invertedCells.mentions ? "#fff" : colorMentions,
    color: invertedCells.mentions ? colorMentions : "#fff",
  }}>
      Association pour la Protection du Patrimoine du Pays des Olonnes
    </div>
  </div>
);

}

IntroScreenLight.propTypes = {
  onEnter: PropTypes.func.isRequired,
  onOpenPresentation: PropTypes.func.isRequired,
  invertedCells: PropTypes.shape({
    titre: PropTypes.bool,
    logo: PropTypes.bool,
    apropos: PropTypes.bool,
    enter: PropTypes.bool,
    mentions: PropTypes.bool,
  }),
};
